module.exports = __webpack_public_path__ + "static/media/delete_icon.6d1bb18a.svg";